// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  /* position: fixed; 
    border-right: 1px solid #dfdfdf; 
    z-index: 11; */
  height: 100%;
  width: 283px;
  /* background: white;*/
  background-color: #313338;
  transition: width 0.25s ease, background 0.25s ease;
  -webkit-transition: width 0.25s ease, background 0.25s ease;
  -moz-transition: width 0.25s ease, background 0.25s ease;
  -ms-transition: width 0.25s ease, background 0.25s ease;

  overflow-y: scroll;
}
.sidebarWraper {
  border-right: 1px solid #dfdfdf;

  display: flex;
  /* width: 285px; */
  height: 1000px;
  padding: 0px 0px 30px 0px;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  flex-shrink: 0;
  background: #fbfbfb;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
}
.minisidebar {
  background: white;
  /* border-right: 1px solid #dfdfdf; */
  width: 70px;
  z-index: 11;
  transition: width 0.25s ease, background 0.25s ease;
  -webkit-transition: width 0.25s ease, background 0.25s ease;
  -moz-transition: width 0.25s ease, background 0.25s ease;
  -ms-transition: width 0.25s ease, background 0.25s ease;
  height: 100vh;
  overflow-y: scroll;
}

* {
  -ms-overflow-style: none;
}

::-webkit-scrollbar {
  display: none;
}

.logoContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0px 0px 0px -5px;
  cursor: pointer;
  height: 91px;
}

.logoContainer .hvr,
.logoContainer:hover .hvH {
  display: none;
}
.logoContainer:hover .hvr {
  display: block;
}

.container_main {
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 100vh;
  background: #fbfbfb;
  /*  background: #FFF; */
}

.sidebar.active ul.nav .accordion-button,
.sidebar.active ul.nav a.nav-link {
  justify-content: center;
}

.subDrops {
  transition: padding 0.3s ease-in-out;
  padding: 0;
  margin: 0;
  list-style: none;
}

.mainWrap header.mainHeader {
  width: calc(100% - 285px);
  position: fixed;
  z-index: 10;
  right: 0;
  top: 0;
}
.collapseView header.mainHeader {
  width: calc(100% - 85px);
  position: fixed;
  z-index: 998;
  right: 0;
  top: 0;
}
.mainWrap .content-sc,
.mainWrap .sidebar_open {
  padding: 100px 20px 5px 299px;
  margin: 0;
}
.collapseView .content-sc,
.collapseView .sidebar_open {
  /*padding: 111px 20px 20px 111px ;*/
  padding: 100px 20px 20px 100px;
  margin: 0;
}

.form-control {
  outline: 0 !important;
  box-shadow: inherit !important;
}
.rect-alignt {
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  margin: 0 5px 0 -10px;
  padding: 0;
}
.ca-details {
  /* margin-left: 20px;*/
}
.mainWrap .content-sc,
.mainWrap .sidebar_open,
.collapseView .content-sc,
.collapseView .sidebar_open {
  min-height: 93vh;
}

.mainWrap .content-sc .sidebar_open,
.collapseView .content-sc .sidebar_open,
.sidebar_open .sidebar_open {
  padding: 0 !important;
  min-height: auto;
}

.sidebar .nav a.nav-link .menuIcon_bx {
  width: 30px;
  text-align: center;
  margin: 0px 0px 0px 20px;
}
span.menuIcon_bx {
  text-align: center;
  margin: 0px 5px 0px 20px !important;
}
.sidebar .nav a.nav-link .menuIcon_bx img {
  /*width: 22px; */
  /* height: auto; */
  max-width: 24px;
  max-height: 23px;
  padding-left: 0px;
  margin-left: -20px;
  filter: brightness(0) invert(1);
}

.sidebar ul.nav li {
  /*margin: 10px 0 25px;*/
  width: 100%;
}
.sidebar .nav span.menu-title {
  /*color: var(--avenu-black, #302B3A);*/
  color: #ffffff;
  font-family: Manrope !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px 0px 0px 10px;
  width: 80%;
  display: inline-block;
}
/* .sidebar ul.nav {
  margin: 15px 0 0;
} */

.sidebar .nav span.menu-title-com {
  /* color: var(--avenu-black, #302B3A); */
  color: #ffffff;
  font-family: Manrope !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px 0px 0px 0px;
  /* width: 153px; */
  display: inline-block;
}

.menuIcon_bx-com {
  width: 100%;
  text-align: center;
  margin: 0px 0px 0px -7px;
  /* display: flex; */
  min-width: 14px;
}

.sidebar span.menu-title-report {
  /* font-size: 16px;
      color: #302B3A;
      font-weight: 500;
      margin-left: 12px;*/

  color: var(--avenu-black, #302b3a);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px 0px 0px 0px;
}
.sidebar .nav a.nav-link {
  /* padding: 0px 10px; */
  /* display: flex; */
  align-items: center;
  /* min-height: inherit; */
  cursor: pointer;
  /* padding-left: 1px !important; */
  /* position: relative; */
  width: 100%;
  /*padding: 15px 10px 15px 20px;*/
  padding: 15px 10px 15px 15px;
}

nav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img 
 .dropdown-contentside .form-menus .new-spans.ml-2.new-letter-side
 {
   left: 65%;
 }
 
 nav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img .arrowrrs-img.arrowrrs-rotate.bulider-arrw-rotate-im {
   margin: -36px -5px 0px 0px;
   width: 45%;
   display: inline-block;
 }
 
 nav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img .arrowrrs-img.bulider-arrw {
   margin: -36px -5px 0px 0px;
   width: 45%;
   display: inline-block;
 }
 nav.sidebar.active .dropdown-contentside.form-menus {
    margin-left: -25px;
 }
 
 img.menu_icon.sub-iicons {
  width: 100%;
  min-width: 25px;
  left: -7px;
  justify-content: normal;}


.new-letter-side {
  background-color: red;
  border-radius: 30px;
  color: #fff;
  font-size: 8px;
  font-weight: 500;
  /* margin-right: 104px; */
  padding: 0px 0px 1px 6px;
  margin-bottom: -4px;
  position: relative;
  width: 15%;
  left: 65%;
}

.new-letter-side-2 {
  background-color: red;
  border-radius: 30px;
  color: #fff;
  font-size: 8px;
  font-weight: 500;
  /* margin-right: 104px; */
  padding: 0px 0px 1px 6px;
  margin-bottom: -3px;
  position: relative;
  width: 15%;
  left: 80%;
}
.sidebar a.nav-link.active {
  /* background: transparent;
     border-radius: 0;
     color: var(--color1);*/
  color: #fff;
  /* border-left: 3px solid #3A68D8; */
  font-weight: 500;
  background: linear-gradient(
    90deg,
    #3a68d8 0%,
    rgba(58, 104, 216, 0) 100%,
    rgba(58, 104, 216, 0) 100%
  );
}
.sidebar a.nav-link.active .menu-title {
  /* color: var(--color1); */
  color: #ffffff;
}
.sidebar a.nav-link.active .menu-title.com {
  /* color: var(--color1); */
  color: #ffffff;
}

.sidebar .nav a.nav-link::before {
  border-left: 3px solid transparent;
}

.sidebar a.nav-link.active::before {
  border-left: 3px solid var(--color1);
  content: " ";
  position: absolute;
  left: -25px;
  top: 0;
  height: 100%;
  z-index: 1;
}
.sidebar.active a.nav-link.active::before {
  left: -10px;
}

.res_icon {
  width: 43px !important;
  padding: 10px;
  margin: 0px 0px 0px -7px;
  display: flex;
}

.switchs {
  position: relative;
  display: flex;
  width: 45px;
  height: 22px;
  margin-left: 10px;
}

.switchs input {
  opacity: 0;
  width: 0;
  height: 0;
}

.sliders {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.sliders:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .sliders {
  background-color: #3a68d8;
}

input:focus + .sliders {
  box-shadow: 0 0 1px #3a68d8;
}

input:checked + .sliders:before {
  transform: translateX(21px);
}

/* Rounded sliders */
.sliders.rounds {
  border-radius: 34px;
}

.sliders.rounds:before {
  border-radius: 50%;
}

.advan-text {
  color: var(--avenu-black, #3a68d8);
  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0 0 0 15px;
}
ul#accordionFlushExample {
  margin: 0px 0px 0px 0px;
}
.vector_icon {
  width: 20px;
  margin: 10px;
}

.last-section {
  margin: 125px 0px 0px 0px;
}
.second-ul {
  /*margin: -20px 0px 0px 0px;
  position: relative; 
    top: 19%;
    margin-top: 115px;*/
  display: flex;
  height: 10vh;
}

button.send-req-btn.rounded.p-2 {
  color: #fff;
  border: 0;
  width: auto;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  max-width: 140px;
  font-size: 15px;
  padding: 10px 10px 10px 10px !important;
}
.give-text {
  margin: 15px 6px 0px 5px;
  /*color: var(--Avenu-Black, #302B3A);*/
  color: #fff;

  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

a.toggle-switch {
  display: flex;
  align-items: flex-end;
}

nav.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sidebar {
  height: 100vh !important;
}

button.btn.btn-primary.dropdown-toggle.logo-bttn {
  color: #949494;
  background: none;
  border: none;
}

.logoContainer .group img {
  width: 75px;
  height: 45px;
}

/* sidebar css 3-11 start */
.first-ul {
  margin-top: 35px;
}
span.advan-text.active {
  color: #3a68d8;
}
.toggle-switch.d-flex.align-items-center {
  margin: 10px 0px;
}
hr {
  border-top: 1px solid #626262 !important;
  width: 100%;
}

.dropdown-container {
  display: none;
  background-color: #262626;
  padding-left: 8px;
}

.dropdown {
  position: relative;
}

.dropdown-btn {
  background: none;
  color: white;
  font-size: 18px;
  border: none;
  width: 100%;
  text-align: left;
  padding: 0px 0px 0px 0px !important;
  cursor: pointer;
}

.dropdown-contentside {
  display: block;
}

/* sidebar css 3-11 end */

.upPsty p {
  margin: 0;
}

.titleAv {
  color: #fff !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  padding: 0 !important;
  display: block !important;
}

a.dropdown-item.drop-text-aligt {
  margin: -7px 0px 0px 0px;
  text-align: center;
}

.userarea .dropdown-item {
  font-size: 13px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.css"],"names":[],"mappings":"AAAA;EACE;;kBAEgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mDAAmD;EACnD,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;;EAEvD,kBAAkB;AACpB;AACA;EACE,+BAA+B;;EAE/B,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;EACX,WAAW;EACX,mDAAmD;EACnD,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,MAAM;AACR;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,MAAM;AACR;AACA;;EAEE,6BAA6B;EAC7B,SAAS;AACX;AACA;;EAEE,mCAAmC;EACnC,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,qBAAqB;AACvB;AACA;;GAEG;;AAEH;EACE,wCAAwC;EACxC,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;;;yBAGuB;;EAEvB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;EAClC,wBAAwB;EACxB,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;GAGG,SAAS;CACX;;CAEA;GACE,0BAA0B;GAC1B,UAAU;GACV,qBAAqB;CACvB;;CAEA;GACE,0BAA0B;GAC1B,UAAU;GACV,qBAAqB;CACvB;CACA;IACG,kBAAkB;CACrB;;CAEA;EACC,WAAW;EACX,eAAe;EACf,UAAU;EACV,uBAAuB,CAAC;;;AAG1B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE;;2BAEyB;EACzB,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB;;;;;GAKC;AACH;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;;;uBAGqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,WAAW;;EAEX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;;AAEzB;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".sidebar {\n  /* position: fixed; \n    border-right: 1px solid #dfdfdf; \n    z-index: 11; */\n  height: 100%;\n  width: 283px;\n  /* background: white;*/\n  background-color: #313338;\n  transition: width 0.25s ease, background 0.25s ease;\n  -webkit-transition: width 0.25s ease, background 0.25s ease;\n  -moz-transition: width 0.25s ease, background 0.25s ease;\n  -ms-transition: width 0.25s ease, background 0.25s ease;\n\n  overflow-y: scroll;\n}\n.sidebarWraper {\n  border-right: 1px solid #dfdfdf;\n\n  display: flex;\n  /* width: 285px; */\n  height: 1000px;\n  padding: 0px 0px 30px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n  flex-shrink: 0;\n  background: #fbfbfb;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1;\n}\n.minisidebar {\n  background: white;\n  /* border-right: 1px solid #dfdfdf; */\n  width: 70px;\n  z-index: 11;\n  transition: width 0.25s ease, background 0.25s ease;\n  -webkit-transition: width 0.25s ease, background 0.25s ease;\n  -moz-transition: width 0.25s ease, background 0.25s ease;\n  -ms-transition: width 0.25s ease, background 0.25s ease;\n  height: 100vh;\n  overflow-y: scroll;\n}\n\n* {\n  -ms-overflow-style: none;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.logoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n  margin: 0px 0px 0px -5px;\n  cursor: pointer;\n  height: 91px;\n}\n\n.logoContainer .hvr,\n.logoContainer:hover .hvH {\n  display: none;\n}\n.logoContainer:hover .hvr {\n  display: block;\n}\n\n.container_main {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  min-height: 100vh;\n  background: #fbfbfb;\n  /*  background: #FFF; */\n}\n\n.sidebar.active ul.nav .accordion-button,\n.sidebar.active ul.nav a.nav-link {\n  justify-content: center;\n}\n\n.subDrops {\n  transition: padding 0.3s ease-in-out;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.mainWrap header.mainHeader {\n  width: calc(100% - 285px);\n  position: fixed;\n  z-index: 10;\n  right: 0;\n  top: 0;\n}\n.collapseView header.mainHeader {\n  width: calc(100% - 85px);\n  position: fixed;\n  z-index: 998;\n  right: 0;\n  top: 0;\n}\n.mainWrap .content-sc,\n.mainWrap .sidebar_open {\n  padding: 100px 20px 5px 299px;\n  margin: 0;\n}\n.collapseView .content-sc,\n.collapseView .sidebar_open {\n  /*padding: 111px 20px 20px 111px ;*/\n  padding: 100px 20px 20px 100px;\n  margin: 0;\n}\n\n.form-control {\n  outline: 0 !important;\n  box-shadow: inherit !important;\n}\n.rect-alignt {\n  color: #fff !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  margin: 0 5px 0 -10px;\n  padding: 0;\n}\n.ca-details {\n  /* margin-left: 20px;*/\n}\n.mainWrap .content-sc,\n.mainWrap .sidebar_open,\n.collapseView .content-sc,\n.collapseView .sidebar_open {\n  min-height: 93vh;\n}\n\n.mainWrap .content-sc .sidebar_open,\n.collapseView .content-sc .sidebar_open,\n.sidebar_open .sidebar_open {\n  padding: 0 !important;\n  min-height: auto;\n}\n\n.sidebar .nav a.nav-link .menuIcon_bx {\n  width: 30px;\n  text-align: center;\n  margin: 0px 0px 0px 20px;\n}\nspan.menuIcon_bx {\n  text-align: center;\n  margin: 0px 5px 0px 20px !important;\n}\n.sidebar .nav a.nav-link .menuIcon_bx img {\n  /*width: 22px; */\n  /* height: auto; */\n  max-width: 24px;\n  max-height: 23px;\n  padding-left: 0px;\n  margin-left: -20px;\n  filter: brightness(0) invert(1);\n}\n\n.sidebar ul.nav li {\n  /*margin: 10px 0 25px;*/\n  width: 100%;\n}\n.sidebar .nav span.menu-title {\n  /*color: var(--avenu-black, #302B3A);*/\n  color: #ffffff;\n  font-family: Manrope !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0px 0px 0px 10px;\n  width: 80%;\n  display: inline-block;\n}\n/* .sidebar ul.nav {\n  margin: 15px 0 0;\n} */\n\n.sidebar .nav span.menu-title-com {\n  /* color: var(--avenu-black, #302B3A); */\n  color: #ffffff;\n  font-family: Manrope !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0px 0px 0px 0px;\n  /* width: 153px; */\n  display: inline-block;\n}\n\n.menuIcon_bx-com {\n  width: 100%;\n  text-align: center;\n  margin: 0px 0px 0px -7px;\n  /* display: flex; */\n  min-width: 14px;\n}\n\n.sidebar span.menu-title-report {\n  /* font-size: 16px;\n      color: #302B3A;\n      font-weight: 500;\n      margin-left: 12px;*/\n\n  color: var(--avenu-black, #302b3a);\n  font-family: Manrope;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0px 0px 0px 0px;\n}\n.sidebar .nav a.nav-link {\n  /* padding: 0px 10px; */\n  /* display: flex; */\n  align-items: center;\n  /* min-height: inherit; */\n  cursor: pointer;\n  /* padding-left: 1px !important; */\n  /* position: relative; */\n  width: 100%;\n  /*padding: 15px 10px 15px 20px;*/\n  padding: 15px 10px 15px 15px;\n}\n\nnav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img \n .dropdown-contentside .form-menus .new-spans.ml-2.new-letter-side\n {\n   left: 65%;\n }\n \n nav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img .arrowrrs-img.arrowrrs-rotate.bulider-arrw-rotate-im {\n   margin: -36px -5px 0px 0px;\n   width: 45%;\n   display: inline-block;\n }\n \n nav.sidebar.active span.menu-title.arrows-btwn.bulider-arrw-img .arrowrrs-img.bulider-arrw {\n   margin: -36px -5px 0px 0px;\n   width: 45%;\n   display: inline-block;\n }\n nav.sidebar.active .dropdown-contentside.form-menus {\n    margin-left: -25px;\n }\n \n img.menu_icon.sub-iicons {\n  width: 100%;\n  min-width: 25px;\n  left: -7px;\n  justify-content: normal;}\n\n\n.new-letter-side {\n  background-color: red;\n  border-radius: 30px;\n  color: #fff;\n  font-size: 8px;\n  font-weight: 500;\n  /* margin-right: 104px; */\n  padding: 0px 0px 1px 6px;\n  margin-bottom: -4px;\n  position: relative;\n  width: 15%;\n  left: 65%;\n}\n\n.new-letter-side-2 {\n  background-color: red;\n  border-radius: 30px;\n  color: #fff;\n  font-size: 8px;\n  font-weight: 500;\n  /* margin-right: 104px; */\n  padding: 0px 0px 1px 6px;\n  margin-bottom: -3px;\n  position: relative;\n  width: 15%;\n  left: 80%;\n}\n.sidebar a.nav-link.active {\n  /* background: transparent;\n     border-radius: 0;\n     color: var(--color1);*/\n  color: #fff;\n  /* border-left: 3px solid #3A68D8; */\n  font-weight: 500;\n  background: linear-gradient(\n    90deg,\n    #3a68d8 0%,\n    rgba(58, 104, 216, 0) 100%,\n    rgba(58, 104, 216, 0) 100%\n  );\n}\n.sidebar a.nav-link.active .menu-title {\n  /* color: var(--color1); */\n  color: #ffffff;\n}\n.sidebar a.nav-link.active .menu-title.com {\n  /* color: var(--color1); */\n  color: #ffffff;\n}\n\n.sidebar .nav a.nav-link::before {\n  border-left: 3px solid transparent;\n}\n\n.sidebar a.nav-link.active::before {\n  border-left: 3px solid var(--color1);\n  content: \" \";\n  position: absolute;\n  left: -25px;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n}\n.sidebar.active a.nav-link.active::before {\n  left: -10px;\n}\n\n.res_icon {\n  width: 43px !important;\n  padding: 10px;\n  margin: 0px 0px 0px -7px;\n  display: flex;\n}\n\n.switchs {\n  position: relative;\n  display: flex;\n  width: 45px;\n  height: 22px;\n  margin-left: 10px;\n}\n\n.switchs input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.sliders {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.sliders:before {\n  position: absolute;\n  content: \"\";\n  height: 17px;\n  width: 17px;\n  left: 4px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n}\n\ninput:checked + .sliders {\n  background-color: #3a68d8;\n}\n\ninput:focus + .sliders {\n  box-shadow: 0 0 1px #3a68d8;\n}\n\ninput:checked + .sliders:before {\n  -webkit-transform: translateX(21px);\n  -ms-transform: translateX(21px);\n  transform: translateX(21px);\n}\n\n/* Rounded sliders */\n.sliders.rounds {\n  border-radius: 34px;\n}\n\n.sliders.rounds:before {\n  border-radius: 50%;\n}\n\n.advan-text {\n  color: var(--avenu-black, #3a68d8);\n  font-family: Manrope;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0 0 0 15px;\n}\nul#accordionFlushExample {\n  margin: 0px 0px 0px 0px;\n}\n.vector_icon {\n  width: 20px;\n  margin: 10px;\n}\n\n.last-section {\n  margin: 125px 0px 0px 0px;\n}\n.second-ul {\n  /*margin: -20px 0px 0px 0px;\n  position: relative; \n    top: 19%;\n    margin-top: 115px;*/\n  display: flex;\n  height: 10vh;\n}\n\nbutton.send-req-btn.rounded.p-2 {\n  color: #fff;\n  border: 0;\n  width: auto;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  max-width: 140px;\n  font-size: 15px;\n  padding: 10px 10px 10px 10px !important;\n}\n.give-text {\n  margin: 15px 6px 0px 5px;\n  /*color: var(--Avenu-Black, #302B3A);*/\n  color: #fff;\n\n  font-family: Manrope;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\na.toggle-switch {\n  display: flex;\n  align-items: flex-end;\n}\n\nnav.sidebar {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.sidebar {\n  height: 100vh !important;\n}\n\nbutton.btn.btn-primary.dropdown-toggle.logo-bttn {\n  color: #949494;\n  background: none;\n  border: none;\n}\n\n.logoContainer .group img {\n  width: 75px;\n  height: 45px;\n}\n\n/* sidebar css 3-11 start */\n.first-ul {\n  margin-top: 35px;\n}\nspan.advan-text.active {\n  color: #3a68d8;\n}\n.toggle-switch.d-flex.align-items-center {\n  margin: 10px 0px;\n}\nhr {\n  border-top: 1px solid #626262 !important;\n  width: 100%;\n}\n\n.dropdown-container {\n  display: none;\n  background-color: #262626;\n  padding-left: 8px;\n}\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown-btn {\n  background: none;\n  color: white;\n  font-size: 18px;\n  border: none;\n  width: 100%;\n  text-align: left;\n  padding: 0px 0px 0px 0px !important;\n  cursor: pointer;\n}\n\n.dropdown-contentside {\n  display: block;\n}\n\n/* sidebar css 3-11 end */\n\n.upPsty p {\n  margin: 0;\n}\n\n.titleAv {\n  color: #fff !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  padding: 0 !important;\n  display: block !important;\n}\n\na.dropdown-item.drop-text-aligt {\n  margin: -7px 0px 0px 0px;\n  text-align: center;\n}\n\n.userarea .dropdown-item {\n  font-size: 13px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
